import { render, staticRenderFns } from "./InsPromotion.vue?vue&type=template&id=64568184&scoped=true"
import script from "./InsPromotion.vue?vue&type=script&lang=ts"
export * from "./InsPromotion.vue?vue&type=script&lang=ts"
import style0 from "./InsPromotion.vue?vue&type=style&index=0&id=64568184&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64568184",
  null
  
)

export default component.exports